var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { AccordionVariant } from './types';
import { colors } from '../../abstracts';
export var AccordionElement = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: column;\n  border-color: ", ";\n  border-style: solid;\n  border-width: 0.125rem;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  width: 100%;\n\n  & > *:last-child {\n    border-width: 0;\n  }\n"], ["\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: column;\n  border-color: ", ";\n  border-style: solid;\n  border-width: 0.125rem;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  width: 100%;\n\n  & > *:last-child {\n    border-width: 0;\n  }\n"])), function (_a) {
    var $variant = _a.$variant;
    return $variant === AccordionVariant.Inline
        ? colors.neutralDeep
        : colors.neutralBright;
});
var templateObject_1;
